export default __webpack_public_path__ + "static/media/discover_bg.a54cd4e8.svg";